import Form from "./form";

export default class ModalForm extends Form {
	constructor(props) {
		super(props);
	}

	beforeInit() {
		super.beforeInit();

		this.$modalTriggers = this.props.$modalTriggers;
		this.hash = this.props.hash;
		this.urlHashes = this.props.urlHashes;

		this.beforeOpen = this.props.beforeOpen;
		this.afterOpen = this.props.afterOpen;
		this.beforeClose = this.props.beforeClose;
		this.afterClose = this.props.afterClose;
		this.modalClass = this.props.modalClass;

		if (this.layout !== 'modal') {
			throw new Error('ModalForm: Layout type must be "modal".');
		}
	}

	addEventListeners() {
		super.addEventListeners();

		let enabledScroll = [];
		const $optLists = this.$root.querySelectorAll('.listbox_opt-list');

		if ($optLists.length) {
			enabledScroll = Array.from($optLists);
		}

		this.serviceLocator.modalService.register(this.formId, this.$modalTriggers, {
			rootClass: this.getModalClassList(),
			hash: this.hash,
			urlHashes: this.urlHashes,
			beforeOpen: this.beforeOpen,
			afterOpen: this.afterOpen,
			beforeClose: this.beforeClose,
			afterClose: this.afterClose,
			enabledScroll
		});
	}

	changeTriggers($triggers = []) {
		if ($triggers.length === 0) {
			return;
		}

		this.serviceLocator.modalService.changeTriggers(this.formId, $triggers);
	}

	getModalClassList() {
		let modalClassList = [];

		if (window.matchMedia('(max-width: 500px)').matches) {
			modalClassList.push('bg-white');
		}

		if (this.modalClass) {
			if (Array.isArray(this.modalClass)) {
				modalClassList.push(...this.modalClass);
			} else if (typeof this.modalClass === 'string') {
				modalClassList.push(...this.modalClass.split(' '));
			}
		}

		return modalClassList;
	}
}